<template>  
  <div class="d-flex align-items-start">
    <a v-if="this.back == true" :href="this.backlink">
      <img src="../assets/images/go_back_icon.png" class="img-fluid pt-1"> 
    </a>
    
    <form id="app" class="w-100 d-flex" @submit="search"> 
      <input type="text" v-model="txt_search" class="form-control transparent-input" placeholder="Cerca...">
      <button type="submit" class="md-addon button-search pt-1"><ficon icon="search" style="font-size:1.7em;"></ficon></button>
    </form>
  </div>   
</template>

<script>

///import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Search',
  data: function() {
    return  { 
      txt_search: null,     
    };
  },
  props: ['callbackSearch','searchKey','backlink','back'],
  methods: { 
    search(e){
        e.preventDefault();
        console.log('SUBMIT')
        if(this.callbackSearch) {
          this.callbackSearch(this.txt_search); 
        }
        else {
          this.$router.push({ path: `/search/${this.txt_search}`}, () => {            
          });        
        }                  
      }   
  },
  created: function(){
    //console.log('created Search', this.searchKey)
    this.txt_search = this.searchKey;
  },
  mounted:function(){
    //this.txt_search = this.searchKey;
    //console.log('mounted ', this.searchKey)    
  },
  computed: {    
     
  }
}
</script>


